<script setup>
import BaseAlert from '@/components/base/BaseAlert.vue'
import ByCustomerTab from '@/components/customer-product-pricing-page/ByCustomerTab.vue'
import ByProductTab from '@/components/customer-product-pricing-page/ByProductTab.vue'

import { ref } from 'vue'
import { useStore } from '@/utils/VuexHelpers'
import { CUSTOMERS } from '@/constants/pagination'

const store = useStore()
const tab = ref('product')

const refreshPrices = async () => {
  await store.dispatch('fetchProductNames')
  store.dispatch('fetchSpecialPricingPageData')
}

//ON CREATED
store.commit('SET_USING_VUETIFY', true)
store.commit('SET_ACTIVE', CUSTOMERS)
refreshPrices()
</script>

<template>
  <v-app>
    <BaseAlert />

    <v-container fluid>
      <div class="wrapper">
        <div class="content-page mt-0">
          <v-row no-gutters class="my-2 align-center">
            <div class="page-title-box d-flex align-center">
              <h4 class="page-title mb-0">Customer Product Pricing</h4>
            </div>

            <v-spacer />

            <v-btn small color="primary" @click="refreshPrices">
              <font-awesome-icon :icon="['fas', 'sync']" class="mr-1" />
              Refresh
            </v-btn>
          </v-row>

          <v-card>
            <v-tabs v-model="tab" background-color="blue-grey lighten-5">
              <v-tab href="#product"> By Product </v-tab>
              <v-tab href="#customer"> By Customer </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
              <ByProductTab />
              <ByCustomerTab />
            </v-tabs-items>
          </v-card>
        </div>
      </div>
    </v-container>
  </v-app>
</template>

<style scoped>
.nested-pricing-table {
  background: #fafafa;
}

.text-muted {
  color: #6c757d;
}

:deep(.text-overline) {
  line-height: 1rem !important;
}
.customer-expand {
  border-bottom: none !important;
}
.expanded-row-cell {
  padding: 0 !important;
  background: #fff;
  border-top: none !important;
}

.expanded-row-wrapper {
  padding: 12px 0 12px 16px;
  background: #fff;
}

:deep(.v-data-table__expanded__content) {
  box-shadow: none !important;
}

:deep(
    .customer-pricing-table
      tbody
      tr.customer-row-expanded
      > td.customer-root-cell
  ),
:deep(
    .product-pricing-table tbody tr.product-row-expanded > td.product-root-cell
  ) {
  border-left: 2px solid #74b2ed !important;
}

:deep(
    .customer-pricing-table tbody tr.customer-row-expanded > td.customer-expand
  ),
:deep(.product-pricing-table tbody tr.product-row-expanded > td.product-expand),
:deep(.product-pricing-table tbody tr.product-row-expanded > td:first-child) {
  border-bottom: none !important;
}

:deep(.product-pricing-table tbody > tr > td:first-child),
:deep(.product-pricing-table thead > tr > th:first-child) {
  padding-right: 2px !important;
}

:deep(.product-pricing-table tbody > tr > td.product-expand),
:deep(.product-pricing-table thead > tr > th:nth-child(2)) {
  padding-left: 2px !important;
}

:deep(.product-pricing-table tbody tr:hover td),
:deep(.customer-pricing-table tbody tr:hover td) {
  background-color: #f8fbff !important;
}

:deep(.product-pricing-table tbody tr:hover .special-price-chip.v-chip),
:deep(.customer-pricing-table tbody tr:hover .special-price-chip.v-chip) {
  background-color: #ffffff !important;
  border-color: #c8d6e3 !important;
}

:deep(.product-pricing-table tbody tr:hover .more-prices-chip.v-chip),
:deep(.customer-pricing-table tbody tr:hover .more-prices-chip.v-chip) {
  background-color: #eaf3ff !important;
  border-color: #90caf9 !important;
}
</style>

<style>
.blue-left-border {
  border-left: 2px solid #74b2ed;
}
</style>
